// extracted by mini-css-extract-plugin
module.exports = {"status":"NetworkHashrateChart_status__OYji0"};